import httpReq from '@/server/http'

const httpRequest = {
  // userLogin: function (params) {
  //   return httpReq('passport/login', 'post', params)
  // }

  // ************************** 登录注册 start ****************

  //登录
  userLogin: function (params) {
    return httpReq('mars-box/passport/login', 'post', params);
  },

  // 退出登录
  userlogout: function (params) {
    return httpReq('mars-box/passport/logout', 'post', params);
  },

  // 获取授权码
  getAccreditCode: function (params) {
    return httpReq('mars-box/passport/foundpwdcode', 'post', params);
  },

  // 获取用户信息
  getUserInfo: function (params) {
    return httpReq('mars-box/personal', 'get', params);
  },

  // 注册
  userRegister: function (params) {
    return httpReq('mars-box/passport/register', 'post', params);
  },

  // 找回密码
  findPasswordByCode: function (params) {
    return httpReq('mars-box/passport/foundpwd', 'post', params);
  },

  // ************************** 登录注册 end ****************

  // **************************发送验证码 start****************

  // 发送登录验证码
  sendLoginCode: function (params) {
    return httpReq('mars-box/passport/sendsms', 'post', params)
  },

  // 发送注册验证码
  sendRegisterCode: function (params) {
    return httpReq('mars-box/passport/sendsms', 'post', params);
  },

  // 忘记密码
  sendFoundPwdCode: function (params) {
    return httpReq('mars-box/passport/sendsms', 'post', params);
  },

  // **************************发送验证码 end****************

  // **************************个人中心 start****************
  // 个人中心信息
  getAccountSetInfo: function (params) {
    return httpReq('mars-box/personal', 'get', params);
  },
  // 修改个人中心信息
  modifyAccountSetInfo: function (params) {
    return httpReq('web/personal', 'post', params);
  },
  // 个人中心修改密码
  modifyPassword: function (params) {
    return httpReq('web/personal/pwd', 'post', params);
  },
  //上传头像(不保存)
  pushPic: function (params) {
    return httpReq('web/personal/avatar', 'postFile', params);
  },
  // 获取子账号权限列表
  getAgentsList: function() {
    return httpReq('mars-box/personal/agents-teacher', 'get');
  },
  // 获取子账号详情
  getAgentDetail: function(params) {
    return httpReq('mars-box/personal/agents-teacher/detail', 'get', params);
  },
  // 新建子账号
  addAgent: function(params) {
    return httpReq('mars-box/personal/agents-teacher/teacher', 'post', params);
  },
  // 编辑子账号详情
  editAgentDetail: function(params) {
    return httpReq('mars-box/personal/agents-teacher', 'post', params);
  },
  // 删除子账号
  deleteAgent: function(params) {
    return httpReq('mars-box/personal/agents-teacher', 'delete', params);
  },
  // **************************个人中心 end****************

  // ************************** 首页 start ****************

  // 获取首页硬件支持数据
  getHomeMarsbox: function (params) {
    return httpReq('web/main/marsbox', 'get', params);
  },

  // 首页师资介绍
  getHomeTeachers: function (params) {
    return httpReq('web/main/teachers', 'get', params);
  },

  // 底部导航
  getFootSlider: function(params){
    return httpReq('web/main/indexbuttom','get',params);
  },
  // 版权信息
  getFooterCopyrightInfo: function(params) {
    return httpReq('web/main/information','get',params);
  },

  // ************************** 首页 end ****************

  // ************************** 课程体系 start ****************

  // 获取课程体系列表
  getHomeCourseList: function (params) {
    return httpReq('mars-box/course-sys', 'get',params);
  },

  // 获取课程体系详情
  getHomeCourseDetail: function (params) {
    return httpReq('mars-box/course-sys/detail', 'get', params);
  },

  // ************************** 课程体系 end ****************

  // ************************** 商城 start ****************

  // 获取商品小件分类
  getProductClass: function () {
    return httpReq('mars-box/mall/goods/tags', 'get');
  },

  // 获取商品小件列表
  getProductList: function (params) {
    return httpReq('mars-box/mall/goods', 'get', params);
  },

  // 获取商品小件详情
  getProductDetail: function (params) {
    return httpReq('mars-box/mall/goods/detail', 'get', params);
  },

  // 获取课程列表
  getCourseList: function (params) {
    return httpReq('mars-box/mall/organ-course', 'get', params);
  },

  // 获取课程详情
  getCourseDetail: function (params) {
    return httpReq('mars-box/mall/organ-course/detail', 'get', params);
  },

  // 获取购物车列表
  getShoppingCartList: function () {
    return httpReq('mars-box/mall/cart', 'get');
  },

  // 获取课程分类列表
  getCourseClassList: function () {
    return httpReq('mars-box/mall/organ-course/cates', 'get');
  },

  // 加入购物车
  addSkuToShoppingCart: function (params) {
    return httpReq('mars-box/mall/cart/sku', 'post', params);
  },

  // 获取购物车内商品数量
  reqShoppingCartTotalNum: function () {
    return httpReq('mars-box/mall/cart/count', 'get');
  },

  // 删除购物车内商品
  delShoppingCart: function (params) {
    return httpReq('mars-box/mall/cart', 'delete', params);
  },

  // 确认订单
  confirmOrder: function (params) {
    return httpReq('mars-box/order/confirm', 'get', params);
  },

  // 下单
  goToPayOrder: function (params) {
    return httpReq('mars-box/order', 'post', params);
  },

  // 发起支付
  goToPay: function (params) {
    return httpReq('mars-box/order/pay', 'get', params);
  },

  // 确认微信支付是否成功
  confirmWXPayOrderStatus: function (params) {
    return httpReq('mars-box/order/callback', 'get', params);
  },

  // 新增or修改收货地址
  addNewAddress: function (params) {
    return httpReq('mars-box/personal/shippingaddress', 'post', params);
  },

  // 获取收货地址列表
  reqAddressList: function (params) {
    return httpReq('mars-box/personal/shippingaddress', 'get', params);
  },

  // 删除收货地址
  redOldAddress: function (params) {
    return httpReq('mars-box/personal/shippingaddress', 'delete', params);
  },

  // 获取我的订单列表
  reqMyOrderList: function (params) {
    return httpReq('mars-box/personal/order', 'get', params);
  },

  // 获取我的订单详情
  reqOrderDetail: function (params) {
    return httpReq('mars-box/personal/order/detail', 'get', params);
  },

  // 获取订单物流信息
  reqLogisticDetail: function (params) {
    return httpReq('mars-box/personal/order/transport', 'get', params);
  },

  // 确认收货
  confirmReceipt: function (params) {
    return httpReq('mars-box/personal/order/over', 'post', params);
  },

  // 获取订单数量
  getOrderCount: function () {
    return httpReq('mars-box/main/startup', 'get');
  },

  // 获取售后订单信息
  detRefundOrder: function (params) {
    return httpReq('mars-box/personal/order/refund', 'get', params);
  },

  // 提交售后订单
  submitRefundOrder: function (params) {
    return httpReq('mars-box/personal/order/refund', 'post', params);
  },

  // 取消订单
  cancelOrder: function (params) {
    return httpReq('mars-box/personal/order/close', 'post', params);
  },

  // 申请开票
  applyBillings: function (params) {
    return httpReq('mars-box/personal/order/invoice', 'post', params);
  },

  // ************************** 商城 end ****************

  // *****************  机构 start  *************************

  // 机构课程广告位
  getInstitutionAdvertisment: function (params) {
    return httpReq('web/organ/course/adv', 'get', params);
  },

  // 机构课程版块列表
  getCourseClassificationList: function (params) {
    return httpReq('web/organ/course/cate', 'get', params);
  },

  // 机构课程列表
  getInstitutionCourseList: function (params) {
    return httpReq('web/organ/course', 'get', params);
  },

  // 机构课程详情
  getInstitutionCourseDetail: function (params) {
    return httpReq('web/organ/course/detail', 'get', params);
  },

  // 机构课程评论列表
  getCourseCommentList: function (params) {
    return httpReq('web/organ/course/comment', 'get', params);
  },

  // 评论机构课程
  postInstitutionCourse: function (params) {
    return httpReq('web/organ/course/comment', 'post', params);
  },

  // 机构课程评论取消点赞
  giveUpTeacherCourseCommentPraisePost: function (params) {
    return httpReq('web/organ/course/comment/praise', 'delete', params);
  },
  // 机构课程评论点赞
  teacherCourseCommentPraisePost: function (params) {
    return httpReq('web/organ/course/comment/praise', 'post', params);
  },
  // 机构兑换课程
  redemptionCourse: function (params) {
    return httpReq('mars-box/redeem', 'post', params);
  },
  // 获取机构课程兑换记录
  reqRedemptionRecord: function (params) {
    return httpReq('mars-box/redeem/record', 'get', params);
  },

  // ******************  机构 end  **************************

  // **************************图片上传 start****************
  // 单张图片上传
  uploadPicture: function (params) {
    return httpReq('web/public/uploadimg', 'postFile', params);
  },
  // 请求七牛token
  requestQiNiuToken: function (params) {
    return httpReq('web/public/qiniutoken', 'get', params);
  },
  // 上传七牛
  uploadVideoToQiNiu: function (params) {
    return httpReq("https://p0rwwxijh.bkt.clouddn.com/", 'post', params)
  },
  // 上传评论图片
  uploadCriticalPic: function (params) {
    return httpReq('web/organ/course/comment/uploadimg', 'postFile', params);
  },
  // 获取评论七牛的token
  getCriticalQiNiuToken: function (params) {
    return httpReq('web/organ/course/comment/qiniutoken', 'get', params);
  },
  // 上传七牛成功后返回信息上传至服务器
  uploadVideoInfo: function (params) {
    return httpReq('web/organ/course/comment/uploadvideo', 'post', params);
  },

  // **************************图片上传 end****************

  // **************************机构论坛 start****************
  // 获取公共轮播图
  getMiniSlider: function (params) {
    return httpReq('web/public/slideshow', 'get', params);
  },
  // 机构论坛版块列表
  getTeacherForumSortnav: function (params) {
    return httpReq('web/organ/post/cate', 'get', params);
  },
  // 机构论坛帖子列表
  getTeacherForumList: function (params) {
    return httpReq('web/organ/post', 'get', params);
  },
  // 机构论坛帖子详情
  getTeacherForumDetail: function (params) {
    return httpReq('web/organ/post/detail', 'get', params);
  },
  // 机构论坛帖子评论列表
  getTeacherForumCommentList: function (params) {
    return httpReq('web/organ/post/comment', 'get', params);
  },
  // 评论机构论坛
  commentTeacherPost: function (params) {
    return httpReq('web/organ/post/comment', 'post', params);
  },
  // 机构论坛点赞
  teacherPraisePost: function (params) {
    return httpReq('web/organ/post/praise', 'post', params);
  },
  // 机构论坛取消点赞
  giveUpTeacherPraisePost: function (params) {
    return httpReq('web/organ/post/praise', 'delete', params);
  },
  // 机构论坛评论点赞
  teacherCommentPraisePost: function (params) {
    return httpReq('web/organ/post/comment/praise', 'post', params);
  },
  // 机构论坛评论取消点赞
  giveUpTeacherCommentPraisePost: function (params) {
    return httpReq('web/organ/post/comment/praise', 'delete', params);
  },
  // 机构论坛我发表的帖子列表
  getTeacherForumSelfList: function (params) {
    return httpReq('web/organ/post', 'get', params);
  },
  // 机构论坛我回复的帖子列表
  getTeacherForumBySelfList: function (params) {
    return httpReq('web/organ/post', 'get', params);
  },
  // 机构论坛发帖
  postingTeacherPost: function (params) {
    return httpReq('web/organ/post', 'post', params);
  },
  // 机构论坛删除帖子
  delateTeacherPost: function (params) {
    return httpReq('web/organ/post', 'delete', params);
  },
  // 机构论坛帖子详情
  getTeacherForumDetail: function (params) {
    return httpReq('web/organ/post/detail', 'get', params);
  },
  // 机构论坛帖子评论列表
  getTeacherForumCommentList: function (params) {
    return httpReq('web/organ/post/comment', 'get', params);
  },
  // **************************机构论坛 end****************

  // **************************科学视频 start****************
  // 科学视频课程列表
  getVideoHomeCourseListDetail: function (params) {
    return httpReq('web/course', 'get', params);
  },
  // 科学视频分类导航
  getVideoListNav: function (params) {
    return httpReq('web/course/video', 'get', params);
  },
  // 科学视频列表
  getVideoList: function (params) {
    return httpReq('web/course/video', 'get', params);
  },
  // 科学视频详情
  getVideoDetail: function (params) {
    return httpReq('web/course/video/detail', 'get', params);
  },
  // 科学视频课程详情
  getVideoCourseDetail: function (params) {
    return httpReq('web/course/detail', 'get', params);
  },
  // **************************科学视频 end****************

  // **************************新闻中心 start****************
  // 新闻中心列表
  getNewsList: function (params) {
    return httpReq('web/news', 'get', params);
  },
  // 新闻中心板块列表
  getNewsCateList: function (params) {
    return httpReq('web/news/cate', 'get', params);
  },
  // 新闻中心详情
  getNewsDetail: function (params) {
    return httpReq('web/news/detail', 'get', params);
  },
  // **************************新闻中心 end****************

  // **************************论坛 start****************
  // 论坛版块列表
  getForumSortnav: function (params) {
    return httpReq('web/post/cate', 'get', params);
  },
  // 论坛帖子列表
  getForumList: function (params) {
    return httpReq('web/post', 'get', params);
  },
  // 论坛贴子详情
  getForumDetail: function (params) {
    return httpReq('web/post/detail', 'get', params);
  },
  // 论坛点赞
  praisePost: function (params) {
    return httpReq('web/post/praise', 'post', params);
  },
  // 论坛取消点赞
  giveUpPraisePost: function (params) {
    return httpReq('web/post/praise', 'delete', params);
  },
  // 论坛评论点赞
  commentPraisePost: function (params) {
    return httpReq('web/post/comment/praise', 'post', params);
  },
  // 论坛评论列表
  getForumCommentList: function (params) {
    return httpReq('web/post/comment', 'get', params);
  },
  // 论坛评论贴子
  commentPost: function (params) {
    return httpReq('web/post/comment', 'post', params);
  },
  // 论坛评论取消点赞
  giveUpCommentPraisePost: function (params) {
    return httpReq('web/post/comment/praise', 'delete', params);
  },
  // 论坛我发表的帖子列表
  getForumSelfList: function (params) {
    return httpReq('web/post', 'get', params);
  },
  // 论坛我回复的帖子列表
  getForumBySelfList: function (params) {
    return httpReq('web/post', 'get', params);
  },
  // 论坛发帖
  postingPost: function (params) {
    return httpReq('web/post', 'post', params);
  },
  // 论坛删除帖子
  delatePost: function (params) {
    return httpReq('web/post', 'delete', params);
  },
  // **************************论坛 end****************

  // **************************关于我们 start****************
  // 团队成员
  getAboutUsTeamMembers: function (params) {
    return httpReq('web/main/teammembers', 'get', params);
  },
  // 意见反馈
  postOpinion: function (params) {
    return httpReq('web/main/feedback', 'post', params);
  },
  // 合作伙伴
  getCompanypartner: function (params) {
    return httpReq('web/main/companypartner', 'get', params);
  },
  // 联系我们
  getConnectionInfo: function (params) {
    return httpReq('web/main/contacts', 'get', params);
  },
  // 人才招聘
  getDemandInfo: function (params) {
    return httpReq('web/main/position', 'get', params);
  },
  // 公司介绍
  getCompanyInfo: function (params) {
    return httpReq('web/main/company', 'get', params);
  },
  // 荣誉证书
  getCertificate: function (params) {
    return httpReq('web/main/certificate', 'get', params);
  },
  // **************************关于我们 end****************

  // **************************机构管理 start****************
  //邀请机构
  inviteAgents: function (params) {
    return httpReq('mars-box/personal/agents-invite', 'post', params);
  },
  //获取机构邀请列表
  reqInviteAgentsList: function (params) {
    return httpReq('mars-box/personal/agents-invite', 'get', params);
  },
  //获取已邀请列表
  reqSignedList: function () {
    return httpReq('mars-box/personal/agents-invite/agents', 'get');
  },
  //获取下单记录列表
  reqOrderList: function (params) {
    return httpReq('mars-box/personal/agents-invite/agentsorder', 'get', params);
  },
  //获取下单记录列表
  reqFreezeDetailList: function (params) {
    return httpReq('mars-box/personal/mars-bean-log', 'get', params);
  },
  // **************************机构管理 end****************

  // **************************编程创作 start****************
  // 获取作品列表
  reqProjrctList: function (params) {
    return httpReq('mars-box/scratch/production', 'get', params);
  },
  // 删除作品
  deleteProject: function (params) {
    return httpReq('mars-box/scratch/production', 'delete', params);
  },
  // 修改作品
  modifyProject: function (params) {
    return httpReq('mars-box/scratch/production', 'post', params);
  },
  // **************************编程创作 end****************

  // *********************  三方机构 自定义配置  start   ***********************
  // 获取机构的所有信息
  // getOrganizationAllInfo: function(params){
  //   return httpReq('', 'get', params);
  // },
  // 获取机构的课程列表信息
  getInstitutionCourse: function(params){
    return httpReq('web/organ_social/organ/course/cates/config', 'get', params); // web/organ_social/organ/course/cate // web/organ_social/organ/course/cate/config
  },
  getInstitutionCourse2: function(params){
    return httpReq('web/organ_social/organ/course/cate', 'get', params); // web/organ_social/organ/course/cate // web/organ_social/organ/course/cate/config
  },
  // 获取机构的配置信息
  getOrganizationConfigInfo: function(params){
    return httpReq('web/organ_social/organ/course/cates/config', 'get', params);
  },

  // *********************  三方机构 自定义配置  end   *************************

  // 再次购买 加入购物车
  reBuyThisProduct: function(params){
    return httpReq('mars-box/mall/cart/ordersku', 'post', params);
  },

  // 获取banner图列表
  getBannerList: function(params){
    return httpReq('banner', 'get', params);
  },
  // 待付款的订单 - 上传发票信息 
  uploadInvoiceData: function(params){
    return httpReq('mars-box/order/invoice', 'post', params);
  },
}

export default httpRequest



// WEBPACK FOOTER //
// ./src/server/http-api.js